import script from "./ConversationControlBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConversationControlBar.vue?vue&type=script&lang=ts&setup=true"

import "./ConversationControlBar.vue?vue&type=style&index=0&id=2308280d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2308280d"]])

export default __exports__